import React, { useState, useCallback, useContext } from "react";
import Dropzone from "react-dropzone";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import {
  upload_org_header_pic,
  upload_org_thumbnail,
} from "../Services/Dashboard/DashboardApi";
import SuccessModel from "./SuccessModel";
import { upload_profile_photo } from "../Services/Student/StudentApi";
import { AuthContext, LoaderContext } from "../Context/ContextProvider";
export default function ImageCropPopup({ onClose, setAddUpdateDone, Type }) {
  const [imageSrc, setImageSrc] = useState(null);
  const { isProfileUpdate, setIsProfileUpdate, userRole } =
    useContext(AuthContext);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const { setLoader } = useContext(LoaderContext);
  const [imageType, setImageType] = useState("image/jpeg");
  const [crop, setCrop] = useState({
    unit: "px",
    width: 200,
    height: 200,
    x: 0,
    y: 0,
  });
  const [imageRef, setImageRef] = useState(null);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    brightness: 100,
    contrast: 100,
    saturate: 100,
  });

  const MAX_SIZE = 2 * 1024 * 1024;
  const isBannerUpload = Type === "Dashboard" || Type === "Header";
  const uploadTitle = isBannerUpload
    ? imageSrc
      ? "Edit Banner Image"
      : "Select Banner Image"
    : imageSrc
      ? "Edit Profile Picture"
      : "Select Profile Picture";
  const uploadHelpText = isBannerUpload
    ? "Recommended banner aspect ratio: 16:5, for example 1600 x 500 px. Max 2 MB."
    : "Recommended profile image aspect ratio: 1:1. Max 2 MB.";

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;
    if (file.size > MAX_SIZE) return setError("File size exceeds 2 MB.");

    setImageType(file.type);
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setError(null);
    };
    reader.readAsDataURL(file);
  }, []);

  const handleImageLoad = (img) => {
    setImageRef(img);
    const aspect = isBannerUpload ? 16 / 5 : 1;
    setCrop({ unit: "%", aspect, width: isBannerUpload ? 80 : 40, x: isBannerUpload ? 10 : 30, y: 10 });
    return true;
  };

  const handleCropSave = async () => {
    if (!imageRef || !crop.width || !crop.height) return;
    setLoader(true);

    const canvas = document.createElement("canvas");
    const scaleX = imageRef.naturalWidth / imageRef.width;
    const scaleY = imageRef.naturalHeight / imageRef.height;

    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.filter = `
            brightness(${filters.brightness}%)
            contrast(${filters.contrast}%)
            saturate(${filters.saturate}%)
        `;
    ctx.drawImage(
      imageRef,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    canvas.toBlob(async (blob) => {
      if (!blob) return;
      const formData = new FormData();
      formData.append("file", blob, "cropped-image.jpg");

      try {
        let response;
        if (userRole === "student_registered" || userRole === "seeker") {
          response = await upload_profile_photo(formData);
        } else {
          if (Type === "Dashboard") {
            response = await upload_org_header_pic(formData);
          } else {
            response = await upload_org_thumbnail(formData);
          }
        }


        setLoader(false);
        if (response.status !== 500 && response.status !== 400) {
          setIsSuccessOpen(true);
        }
      } catch (err) {
        setLoader(false);
        console.error("Upload Error:", err);
      }
    }, imageType || "image/jpeg");
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: 10,
          width: "80%",
          maxWidth: 600,
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        {/* Sticky Header */}
        <div
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 10,
            padding: "15px 20px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h5 style={{ margin: 0 }}>{uploadTitle}</h5>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 20,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        {/* Scrollable Content */}
        <div style={{ flex: 1, overflowY: "auto", padding: 20 }}>
          {!imageSrc ? (
            <>
              <Dropzone
                onDrop={onDrop}
                accept={{ "image/*": [] }}
                maxFiles={1}
                multiple={false}
              >
                {({ getRootProps, getInputProps, isDragActive }) => (
                  <div
                    {...getRootProps()}
                    style={{
                      border: "2px dashed #ccc",
                      padding: 30,
                      height: "60vh",
                      textAlign: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      borderRadius: 8,
                      transition: "border-color 0.3s",
                      backgroundColor: isDragActive ? "#e0f7fa" : "#fff",
                    }}
                  >
                    <input {...getInputProps()} />
                    <div>{isDragActive ? "Drop the image here..." : "Drag & drop or click to select image"}</div>
                    <div style={{ marginTop: 8, fontSize: 12, color: "#6c757d" }}>{uploadHelpText}</div>
                  </div>
                )}
              </Dropzone>
              {error && <p style={{ color: "red", marginTop: 10 }}>{error}</p>}
            </>
          ) : (
            <>
              <ReactCrop
                crop={crop}
                onChange={(newCrop) => setCrop(newCrop)}
                onComplete={(c) => setCrop(c)}
                onImageLoaded={handleImageLoad}
                aspect={crop.aspect}
              >
                <img
                  src={imageSrc}
                  alt="Crop Preview"
                  ref={(img) => img && setImageRef(img)}
                  style={{
                    width: "100%",
                    maxHeight: 400,
                    objectFit: "contain",
                    filter: `
                                            brightness(${filters.brightness}%)
                                            contrast(${filters.contrast}%)
                                            saturate(${filters.saturate}%)
                                        `,
                  }}
                />
              </ReactCrop>

              <div style={{ marginTop: 20 }}>
                {[
                  { label: "Brightness", key: "brightness" },
                  { label: "Contrast", key: "contrast" },
                  { label: "Saturation", key: "saturate" },
                ].map((filter) => (
                  <div key={filter.key} style={{ marginBottom: 15 }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 5,
                        fontWeight: 500,
                      }}
                    >
                      {filter.label}
                    </label>
                    <input
                      type="range"
                      min="0"
                      max="200"
                      value={filters[filter.key]}
                      onChange={(e) =>
                        setFilters((f) => ({
                          ...f,
                          [filter.key]: +e.target.value,
                        }))
                      }
                      style={{ width: "100%" }}
                    />
                  </div>
                ))}
              </div>

              <div
                className="sticky-button-box"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 20,
                }}
              >
                <button
                  className="button upload-btn"
                  onClick={handleCropSave}
                  style={{
                    backgroundColor: "#235594",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                >
                  Crop & Save
                </button>
                {/* <button
                  className="button clear-btn"
                  onClick={() => setImageSrc(null)}
                  style={{
                    backgroundColor: "#f44336",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                >
                  Clear Image
                </button> */}
              </div>
            </>
          )}
        </div>
      </div>

      <SuccessModel
        isOpen={isSuccessOpen}
        title="Success!"
        message="Image updated successfully!"
        buttonText="OK"
        onClose={() => {
          setAddUpdateDone(true);
          setIsSuccessOpen(false);
          onClose();
        }}
      />
    </div>
  );
}
